module.exports = __webpack_public_path__ + "static/img/b07.5335e3a.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/b07.jpg
// module id = 9JW6
// module chunks = 1